import React from "react";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell, X } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

export default function NotificationsBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const i = setInterval(load, 30000);
    return () => clearInterval(i);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const markAllRead = async () => {
    try {
      await api.post("/notifications/read-all");
      load();
    } catch (e) {
      // ignore
    }
  };

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o && unread > 0) markAllRead(); }}>
      <PopoverTrigger asChild>
        <button
          className="relative p-2 rounded-md hover:bg-zinc-100 transition-colors duration-200"
          data-testid="notifications-bell"
          aria-label="Notifications"
        >
          <Bell size={18} strokeWidth={1.5} className="text-zinc-700" />
          {unread > 0 && (
            <span className="absolute top-1 right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="notifications-badge">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0 border-zinc-200">
        <div className="p-3 border-b border-zinc-200 flex items-center justify-between">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Notifications</div>
          <Button variant="ghost" size="sm" onClick={() => setOpen(false)} className="h-6 w-6 p-0"><X size={14} /></Button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && (
            <div className="p-6 text-sm text-zinc-500 text-center">No notifications yet.</div>
          )}
          {items.map((n) => (
            <div key={n.id} className={`p-3 border-b last:border-b-0 border-zinc-100 ${!n.read ? "bg-amber-50/40" : ""}`} data-testid={`notification-${n.id}`}>
              <div className="text-sm text-zinc-800 leading-snug">{n.message}</div>
              <div className="text-xs text-zinc-400 mt-1 tabular-nums">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
